import { Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Action, ConfirmDialogConfig, CrudConfirmDialogComponent, CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, FormStorage, openCrudRowsEditorDialogInAttributeEditorMode, REPOSITORY_FILE_ROWS_TYPE, UserStorage } from '@scisys-uim/uim-common';
import { AMMUNITION_STOCK_EVENT_TYPE, Firearm, FIREARM_TYPE, Ranger, RANGER_FIREARM_ASSIGNMENT_LOG_TYPE, RANGER_STATUS_ACTIVE, RANGER_STATUS_CLOSED, RANGER_STATUS_ON_LEAVE, RANGER_STATUS_PENDING, RANGER_TYPE } from 'assets-model';
import { AmmunitionStockEventService, FirearmAssignmentLogService, RangerDocumentPermission, RangerDocumentService, RangerService } from 'assets-service';
import { Observable, range } from 'rxjs';
import { map } from 'rxjs/operators';
import { FirearmAssignmentCreationDialogComponent, FirearmAssignmentCreationDialogConfigData, FirearmAssignmentCreationDialogData } from '../../firearm_assignment/dialog/firearm-assignment-creation-dialog.component';
import { RangerLeavingDialogComponent, RangerLeavingDialogConfigData } from '../dialog/ranger-leaving-dialog.component';
import { RangerSetToPendingDialogComponent, RangerSetToPendingDialogConfigData } from '../dialog/ranger-set-to-pending-dialog.component';
import { RangerOnLeaveDialogComponent, RangerOnLeaveDialogConfigData } from '../dialog/ranger-on-leave-dialog.component';
import { openJustfoneDataTransferDialog } from '../../datatransfer/dialog/justfone-data-transfer-dialog.component';
import { RangerDocumentEditDialogComponent, RangerDocumentEditDialogConfig, RangerDocumentRowsComponent, RangerDocumentRowsComponentMode } from './ranger-document-rows.component';


@Component({
  selector: 'app-ranger-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class RangerEditorComponent extends CrudEditComponent<Ranger, number> implements OnInit {


  firearmSelectionListFilterLoad?: (text: string) => Observable<Firearm[]>;

  private rangerDocumentsPermissions: RangerDocumentPermission[];

  constructor(
    protected rangerDocumentService: RangerDocumentService,
    private rangerService: RangerService,
    private ammunitionStockEventService: AmmunitionStockEventService,
    private firearmAssignmentLogService: FirearmAssignmentLogService,
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);

    this.firearmSelectionListFilterLoad = (text) => {
      return this.firearmAssignmentLogService.findByFullFiltersExtended({
        firearmFilter: {
          assetFilter: {
            buId: this.item.businessUnit?.buId,
            text: text
          },
          includeNonPoolFirearms: true,
          firearmPoolFilter: {
            containsMemberId: this.item.rangerId
          }
        },
        currentAssignmentTypes: ['STORAGE'],
        currentAssignmentFilter: {
          currentAssignment: true,
          includeIssuedPoolFirearms: true,
          excludeIssuedPoolFirearmsForRangerId: this.item.rangerId,
          includeTemporaryStorageFirearms: false
        },
        lifecycleState: 'IN_SERVICE',
        pendingActions: false
      }, null, true, true).pipe(map(result => {
        return result.items?.map(i => i.firearm);
      }));
    };
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();
    const self = this;
    this.actions = [];

    this.actions.push(<Action>{
      title: 'Assign Firearm Asset',
      get enabled(): boolean {
        return true;
      },
      color: true,
      get available(): boolean {
        return !self.createMode && !self.readOnly && self.userStorage.currentUserHasAnyAuthority(['CREATE_FIREARM_ASSIGNMENT']) && self.item?.status == RANGER_STATUS_ACTIVE && !self.item.volunteerRanger;
      },
      doAction(...args) {
        self.openAssignFirearmPopup();
      }
    });

    this.actions.push(<Action>{
      title: 'Reactivate',
      get enabled(): boolean {
        return true;
      },
      color: true,
      get available(): boolean {
        return !self.createMode && !self.readOnly && self.userStorage.currentUserHasAnyAuthority(['RANGER_ACTIVATE']) && self.item?.status == RANGER_STATUS_PENDING || self.item?.status == RANGER_STATUS_CLOSED;
      },
      doAction(...args) {
        self.openRangerActivatePopup();
      }
    });

    this.actions.push(<Action>{
      title: 'Set as Pending',
      get enabled(): boolean {
        return true;
      },
      color: true,
      get available(): boolean {
        return !self.createMode && !self.readOnly && self.userStorage.currentUserHasAnyAuthority(['SET_RANGER_PENDING']) && self.item?.status == RANGER_STATUS_ACTIVE;
      },
      doAction(...args) {
        self.openRangerSetToPendingPopup();
      }
    });

    this.actions.push(<Action>{
      title: 'Set as On Leave',
      get enabled(): boolean {
        return true;
      },
      color: true,
      get available(): boolean {
        return !self.createMode && !self.readOnly && self.userStorage.currentUserHasAnyAuthority(['SET_RANGER_ON_LEAVE']) && self.item?.status == RANGER_STATUS_ACTIVE;
      },
      doAction(...args) {
        self.openRangerSetToOnLeavePopup();
      }
    });

    this.actions.push(<Action>{
      title: 'Return From Leave',
      get enabled(): boolean {
        return true;
      },
      color: true,
      get available(): boolean {
        return !self.createMode && !self.readOnly && self.userStorage.currentUserHasAnyAuthority(['SET_RANGER_ON_LEAVE']) && self.item?.status == RANGER_STATUS_ON_LEAVE;
      },
      doAction(...args) {
        self.openRangerReturnFromLeavePopup();
      }
    });

    this.actions.push(<Action>{
      title: 'Ranger Leaving FE',
      get enabled(): boolean {
        return true;
      },
      color: true,
      get available(): boolean {
        return !self.createMode && !self.readOnly && self.userStorage.currentUserHasAnyAuthority(['PROCESS_RANGER_LEAVING']) && self.item?.status != RANGER_STATUS_CLOSED;
      },
      doAction(...args) {
        self.openRangerLeavingPopup();
      }
    });

    this.actions.push(<Action>{
      title: 'View/Upload Documents',
      get enabled(): boolean {
        return self.isRangerDocumentsEnabled();
      },
      color: true,
      get available(): boolean {
        return self.isRangerDocumentsAvailable();
      },
      doAction() {
        self.openRangerDocumentDialog();
      }
    });

    this.actions.push(<Action>{
      title: 'Assignment Log',
      get enabled(): boolean {
        return self.userStorage.currentUserHasAnyAuthority(RANGER_FIREARM_ASSIGNMENT_LOG_TYPE.editAuthorities) || self.userStorage.currentUserHasAnyAuthority(RANGER_FIREARM_ASSIGNMENT_LOG_TYPE.viewAuthorities);
      },
      color: true,
      get available(): boolean {
        return self.item?.rangerId != null;
      },
      get route() {
        const useEditRoute = self.userStorage.currentUserHasAnyAuthority(RANGER_FIREARM_ASSIGNMENT_LOG_TYPE.editAuthorities) && !self.readOnly;
        const routeBase = useEditRoute ? RANGER_FIREARM_ASSIGNMENT_LOG_TYPE.editRouteBase : RANGER_FIREARM_ASSIGNMENT_LOG_TYPE.viewRouteBase;
        return [...routeBase, self.item?.rangerId]
      },
      getQueryParams() {
        return {
          ...self.currentRouteBackRouteQueryParams(),
          rangerId: self.item?.rangerId
        };
      }
    });
    this.actions.push(<Action>{
      title: 'Ammunition History',
      get enabled(): boolean {
        return self.userStorage.currentUserHasAnyAuthority(AMMUNITION_STOCK_EVENT_TYPE.viewAuthorities);
      },
      color: true,
      get available(): boolean {
        return self.item?.rangerId != null;
      },
      get route() {
        return [...AMMUNITION_STOCK_EVENT_TYPE.rangerHistoryRouteBase, self.item?.rangerId];
      },
      getQueryParams() {
        return self.currentRouteBackRouteQueryParams();
      }
    });
    this.actions.push(<Action>{
      title: 'Firearms Card Report',
      get enabled(): boolean {
        return self.userStorage.currentUserHasAnyAuthority(FIREARM_TYPE.viewAuthorities)
      },
      color: true,
      get available(): boolean {
        return self.item?.rangerId != null;
      },
      doAction() {
        self.rangerService.exportRangerAssignedFirearmsReport(self.item.rangerId, 'PDF', false);
      },
    });
    this.actions.push(<Action>{
      title: 'Resend Ammunition Emails',
      get enabled(): boolean {
        return self.userStorage.currentUserHasAnyAuthority(FIREARM_TYPE.viewAuthorities)
      },
      color: true,
      get available(): boolean {
        return self.item?.rangerId != null;
      },
      doAction() {
        self.resendAmmunitionIssueAcknowledgement();
      },
    });

    this.actions.push(<Action>{
      title: 'Justfone Debug',
      get enabled(): boolean { return !self.unsavedChanges() },
      color: "primary",
      get available(): boolean {
        return self.currentUserHasAnyAuthority("IS_SUPERUSER");
      },
      doAction() {
        openJustfoneDataTransferDialog(self.dialog, 'Ranger', self.item.rangerId);
      }
    });
    if (this.item?.rangerId != null) {
      this.rangerDocumentService.getRangerPermissions(this.item.rangerId, null).subscribe(permissions => this.rangerDocumentsPermissions = <RangerDocumentPermission[]>permissions);
    }
  }

  resendAmmunitionIssueAcknowledgement() {
    this.openSimpleConfirmationDialog("Resend Ammunition Issue Acknowledgement", "This will resend any ammunition issue acknowledgement emails that have not been acknowledged by the ranger (If any exist). Are you sure?", "Resend").afterClosed().subscribe(
      result => {
        if (result) {
          this.ammunitionStockEventService.resendAcknowledgeEmails(this.item.rangerId).subscribe(() => {
            this.openSnackbar('Ammunition Issue Acknowledgement Emails Re-Sent');
          });
        }
      }
    );
  }

  openAssignFirearmPopup() {
    if (this.item.policeContact == null) {
      this.openSimpleMessageDialog("Cannot assign firearms to a Ranger without a Police Contact. These are required to notify police of changes in firearms holdings.", "Missing Police Contact", "OK");
    } else {
      var ref: MatDialogRef<FirearmAssignmentCreationDialogComponent, FirearmAssignmentCreationDialogData> = this.dialog.open(FirearmAssignmentCreationDialogComponent, {
        panelClass: 'dialog-resizable',
        height: '600px',
        width: '900px',
        data: <FirearmAssignmentCreationDialogConfigData>{
          ranger: this.item,
          firearmAssignmentType: 'ISSUE',
          firearmSelectionListFilterLoad: this.firearmSelectionListFilterLoad
        }
      })
      ref.afterClosed().subscribe(
        result => {
          if (result != null) {
            this.openSnackbar('Ranger Firearms Assignment Created');
          }
        }
      );
    }
  }

  
  openRangerSetToOnLeavePopup() {
    var ref: MatDialogRef<RangerOnLeaveDialogComponent, RangerOnLeaveDialogConfigData> = this.dialog.open(RangerOnLeaveDialogComponent, {
      panelClass: 'dialog-resizable',
      height: '600px',
      width: '900px',
      data: <RangerOnLeaveDialogConfigData>{
        ranger: this.item,
      }
    })
    ref.afterClosed().subscribe(
      result => {
        if (result != null) {
          this.openSnackbar('Ranger Set as On Leave');
          this.service.get(result.ranger.rangerId).subscribe(ranger => {
            this.postSave(ranger);
            this.itemComponent.setDefaultDisabledFields();
          });
        }
      }
    );
  }

  openRangerReturnFromLeavePopup() {
    var ref: MatDialogRef<CrudConfirmDialogComponent, boolean> = this.openConfirmationDialog(this.item, {
      data: <ConfirmDialogConfig<Ranger, number>>{
        title: 'Return Ranger From Leave?',
        action: 'Confirm',
      }
    });
    ref.afterClosed().subscribe(
      result => {
        if (result) {
          this.rangerService.rangerReturnFromLeave(this.item.rangerId).subscribe(ranger => {
            this.openSnackbar('Ranger No Longer On Leave');
            this.service.get(ranger.rangerId).subscribe(ranger => {
              this.postSave(ranger);
              this.itemComponent.setDefaultDisabledFields();
            });
          });
        }
      }
    );
  }

  openRangerSetToPendingPopup() {
    var ref: MatDialogRef<RangerSetToPendingDialogComponent, RangerSetToPendingDialogConfigData> = this.dialog.open(RangerSetToPendingDialogComponent, {
      panelClass: 'dialog-resizable',
      height: '600px',
      width: '900px',
      data: <RangerSetToPendingDialogConfigData>{
        ranger: this.item,
      }
    })
    ref.afterClosed().subscribe(
      result => {
        if (result != null) {
          this.openSnackbar('Ranger Set as Pending');
          this.service.get(result.ranger.rangerId).subscribe(ranger => {
            this.postSave(ranger);
            this.itemComponent.setDefaultDisabledFields();
          });
        }
      }
    );
  }

  openRangerLeavingPopup() {
    var ref: MatDialogRef<RangerLeavingDialogComponent, RangerLeavingDialogConfigData> = this.dialog.open(RangerLeavingDialogComponent, {
      panelClass: 'dialog-resizable',
      height: '600px',
      width: '900px',
      data: <RangerLeavingDialogConfigData>{
        ranger: this.item,
      }
    })
    ref.afterClosed().subscribe(
      result => {
        if (result != null) {
          this.openSnackbar('Ranger Closed');
          this.service.get(result.ranger.rangerId).subscribe(ranger => {
            this.postSave(ranger);
            this.itemComponent.setDefaultDisabledFields();
          });
        }
      }
    );
  }

  openRangerActivatePopup() {
    var ref: MatDialogRef<CrudConfirmDialogComponent, boolean> = this.openConfirmationDialog(this.item, {
      data: <ConfirmDialogConfig<Ranger, number>>{
        title: 'Activate Ranger?',
        action: 'Confirm',
      }
    });
    ref.afterClosed().subscribe(
      result => {
        if (result) {
          this.rangerService.rangerActivate(this.item.rangerId).subscribe(ranger => {
            this.openSnackbar('Ranger Activated');
            this.service.get(ranger.rangerId).subscribe(ranger => {
              this.postSave(ranger);
              this.itemComponent.setDefaultDisabledFields();
            });
          });
        }
      }
    );
  }

  openRangerDocumentDialog() {
    var showActions = [];
    var modesAvailable: RangerDocumentRowsComponentMode[] = [];
    if (this.userDetails.hasAnyAuthority('READ_RANGER_DOCUMENT')) {
      showActions.push('download');
      modesAvailable.push('LIST_DOCUMENTS');
    }
    if (this.userDetails.hasAnyAuthority('UPLOAD_RANGER_DOCUMENT')) {
      showActions.push('delete');
      modesAvailable.push('UPLOAD_DOCUMENTS');
    }
    var title = 'Ranger Documents';
    const dialogConfig: RangerDocumentEditDialogConfig<number> = {
      dialogTitle: title,
      showActions: showActions,
      modesAvailable: modesAvailable,
      permissions: this.rangerDocumentsPermissions,
      ranger: this.item,
      allowSelectUploadDocType: true,
      config: {
        rowsItemComponentType: RangerDocumentRowsComponent,
        rowsType: REPOSITORY_FILE_ROWS_TYPE,
        readOnly: false
      },
      supportsAdd: false,
      supportsSave: false,
      rows: [],
    };

    const dialogRef = openCrudRowsEditorDialogInAttributeEditorMode(this.dialog, {
      panelClass: ['contract-document-dialog', 'dialog-resizable'],
      height: '80vh',
      minWidth: '60vw',
      //minHeight: '70vh',
      data: dialogConfig
    }, RangerDocumentEditDialogComponent);
  }

  isRangerDocumentsAvailable() {
    return this.userDetails.hasAnyAuthority('READ_RANGER_DOCUMENT');
  }

  isRangerDocumentsEnabled() {
    return this.rangerDocumentsPermissions?.length > 0;
  }

}






